import "./App.css";
import { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Contexts and Components
import { CartProvider } from "./components/Cart/CartContext";
import NavBar from "./components/NavBar";
import Hero from "./components/Bots/Hero";
import About from "./components/Bots/About";
import Testimonials from "./components/Bots/Testimonials";
import Footer from "./components/Bots/Footer";
import Bots from "./components/Bots/Bots";
import Forex from "./components/Forex/Forex";
import Cart from "./components/Cart/Cart";
import WhatsAppWidget from "./components/UI/WhatsappWidget";
import TradeAnalyzerPage from "./components/ForexTradingTool/TradeAnalyzerPage";
import Login from "./components/Logins/Login";
import Signup from "./components/Logins/Signup";
import PrivateRoute from "./components/Auth/PrivateRoute";
import ForgotPassword from "./components/Logins/ForgotPassword";
import ResetPassword from "./components/Logins/ResetPassword";
import VerifyEmail from "./components/Logins/VerifyEmail";

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return null;
}

function App() {
  const [isCartOpen, setCartOpen] = useState(false);
  // const navigate = useNavigate();

  // 🔐 Clear session on browser/tab close
  useEffect(() => {
    const handleUnload = () => {
      sessionStorage.removeItem("user");
    };

    window.addEventListener("beforeunload", handleUnload);
    return () => window.removeEventListener("beforeunload", handleUnload);
  }, []);

  return (
    <div className="App">
      <CartProvider>
        <ScrollToHash />
        <NavBar onCartClick={() => setCartOpen(true)} />

        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          <Route
            path="/"
            element={
              <>
                <Hero />
                <section id="about">
                  <About />
                </section>
                <section id="bots">
                  <Bots />
                </section>
                <Forex />
                <section id="testimonials">
                  <Testimonials />
                </section>
                <Footer />
              </>
            }
          />

          <Route
            path="/trade-analyzer"
            element={
              <PrivateRoute>
                <TradeAnalyzerPage />
              </PrivateRoute>
            }
          />
        </Routes>

        <Cart isOpen={isCartOpen} onClose={() => setCartOpen(false)} />
        <WhatsAppWidget />
        <ToastContainer />
      </CartProvider>
    </div>
  );
}

export default App;
